// Navis guest chat (loaded via GTM) injects its launch button and chat window
// as iframes without an accessible name (WCAG 4.1.2), so label them on insert.
function label(frame) {
  if (frame.title) return;

  frame.setAttribute('title', frame.classList.contains('bfFrame--window') ? 'Reservations chat' : 'Chat with Reservations');
}

export default function navisChat() {
  document.querySelectorAll('iframe.bfFrame').forEach(label);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeName === 'IFRAME' && node.classList.contains('bfFrame')) label(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
